import { React, PropTypes, Modal, FelaComponent } from '../dependencies';

const imageRule = ({ theme }) => ({
    width: '100%',
    height: 'auto',
    cursor: 'pointer',
});

class ImageMenu extends React.Component {
    state = { visible: false };

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    render() {
        const { data } = this.props;
        const imageMenu = (
            <FelaComponent
                rule={imageRule}
                render={({ className }) => (
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                    <img className={className} src={data} onClick={this.showModal} alt="Menu" />
                )}
            />
        );

        return (
            <React.Fragment>
                {imageMenu}
                <Modal closable width={900} visible={this.state.visible} onCancel={this.handleCancel} footer={null}>
                    {imageMenu}
                </Modal>
            </React.Fragment>
        );
    }
}

ImageMenu.propTypes = {
    data: PropTypes.string.isRequired,
};

export default ImageMenu;
